export default () => {
    $(window).load(function() {
       $("#gl-circle-loader-wrapper").fadeOut(500);
    })
};



/** WEBPACK FOOTER **
 ** ./assets/src/js/pageLoading/pageLoading.js
 **/